import { render, staticRenderFns } from "./TableOwnersBooking.vue?vue&type=template&id=7c645369&scoped=true&"
import script from "./TableOwnersBooking.vue?vue&type=script&lang=js&"
export * from "./TableOwnersBooking.vue?vue&type=script&lang=js&"
import style0 from "./TableOwnersBooking.vue?vue&type=style&index=0&id=7c645369&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c645369",
  null
  
)

export default component.exports